import { SERVICE_LEAD_TYPE } from 'src/constants/lead/leadTypes';
import type { TServiceClientFormValues } from './types';

export type TBuildCreateServiceClientBodyOptions = {
    createdBy: string;
};

/**
 * Build the body for POST /service-clients/create.
 * Use make/makeName and vehicleId/model already saved in the form. Only add createdAt and createdBy.
 */
export function buildCreateServiceClientBody(
    values: TServiceClientFormValues,
    options: TBuildCreateServiceClientBodyOptions
): Record<string, unknown> {
    const now = new Date().toISOString();
    const { createdBy } = options;

    const vehicles = (values.service?.vehicles ?? []).map((v) => {
        const vehicle: Record<string, unknown> = {
            make: { _id: v.make, name: v.makeName },
            model: v.model,
            modelType: v.modelType,
            year: v.year,
            vin: v.vin,
            kilometers: v.kilometers,
            createdAt: now,
            createdBy,
        };
        if (v.vehicleId) vehicle._id = v.vehicleId;

        return {
            vehicle,
            serviceHistory: [],
        };
    });

    return {
        name: values.name,
        email: values.email,
        phone: values.phone,
        countryCode: values.countryCode,
        source: values.source,
        store: values.store,
        type: SERVICE_LEAD_TYPE,
        service: {
            vehicles,
        },
    };
}
